import { gql } from '@apollo/client';

import { SearchOrderConnectionFragment } from '../fragments/searchOrderConnectionFragment.gql';

/**
 * Query to search orders with pagination support
 * Uses cursor-based pagination with connection pattern
 *
 * @param first - Number of results to fetch
 * @param after - Cursor to fetch results after (for next page)
 * @param query - Search criteria (keywords, supplierRefId, etc.)
 */
export const GetOrdersQuery = gql`
  query GetOrders($first: Int, $after: String, $query: SearchOrderInput!) {
    searchOrder(first: $first, after: $after, query: $query) {
      ...SearchOrderConnectionFragment
      ... on InputValidationFailure {
        message
      }
    }
  }
  ${SearchOrderConnectionFragment}
`;
